import { render, staticRenderFns } from "./ShareTalentCard.vue?vue&type=template&id=20a482d6&scoped=true&"
import script from "./ShareTalentCard.vue?vue&type=script&lang=js&"
export * from "./ShareTalentCard.vue?vue&type=script&lang=js&"
import style0 from "./ShareTalentCard.vue?vue&type=style&index=0&id=20a482d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a482d6",
  null
  
)

export default component.exports